'use client';

import { useUserContext } from '@/context/user';
import { clsx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { Fragment, useState } from 'react';
import downArrowPng from '../../assets/images/rewards-program/down-arrow.png';

const FrequentlyQuestion = props => {
  const [isExpand, setIsExpand] = useState(false);
  const [{ isSignedIn }] = useUserContext();

  const faqs = [
    {
      question: 'What is The Kingsyard Rewards Program?',
      answer: (
        <>
          <p>
            The Kingsyard Rewards Program offers membership benefits and point rewards. Earn membership benefits by
            meeting the level requirements through shopping! Earn points by engaging with us, following us and
            contributing in the Facebook group, then use the points to deduct the order price or redeem discount codes.
            Stay tuned for more ways to earn points in the future!
          </p>
          <p className={clsx('mt-4')}>
            Becoming a member implies your agreement to adhere to these terms and conditions. Kingsyard reserves the
            right to modify, update, or terminate the membership criteria at any time, including changes to level status
            and rewards. Ultimately, Kingsyard holds the final interpretation authority.
          </p>
        </>
      ),
    },
    {
      question: 'How do I sign up for The Kingsyard Rewards Program?',
      answer: (
        <>
          <p>If you have registered our website, you have joined Kingsyard Rewards Program by default.</p>
          <p className={clsx('mt-4', !!isSignedIn && 'hidden')}>
            <span>
              If you&apos;ve registered on our website, you&apos;re automatically enrolled in the Kingsyard Rewards
              Program. If not, you can join by
            </span>
            &nbsp;
            <Link
              href='/create-account'
              className={clsx('underline hover_text-[#656363] ')}
            >
              creating an account!
            </Link>
          </p>
        </>
      ),
    },
    {
      question: 'What are the membership levels available? How can I reach the next level?',
      answer: (
        <>
          <p>
            Kingsyard VIP offers four different levels: K0 (for registered members), and K1, K2, K3 (for purchasing
            members). Your level is determined by your spending in the current year and remains valid for that year.
            Once you reach K1 level, you&apos;ll enjoy lifetime status unless you terminate your membership.
          </p>
          <p className={clsx('mt-4')}>
            Please note that membership levels and annual spending reset on January 1st each year.
          </p>
        </>
      ),
    },
    {
      question: 'How do I earn points?',
      answer:
        'Earn points by registering, shopping, inviting friends, leaving product reviews, following us on social media, and participating in our Facebook groups, among other activities.',
    },
    {
      question: 'What can I redeem my points for?',
      answer: (
        <>
          <p>
            Use your reward points to redeem coupons on the rewards program page or deduct the order price during
            checkout (50 points = $1).
          </p>
          <p className={clsx('mt-4')}>
            Note that a minimum of 50 points is required for redemption, with a maximum redemption of 500 points. Points
            are can&apos;t be used for shipping charges and taxes.
          </p>
        </>
      ),
    },
    {
      question: 'How to claim my reward points for previous orders placed on amazon?',
      answer:
        'After registering as a member, go to the "EARN POINTS - AMAZON ORDER REDEEM" section, and fill in your order number to claim your points. Once confirmed, your points will be added to your reward points balance.',
    },
    {
      question: 'Where can I find my reward points balance and records?',
      answer:
        'Check your point balance and records on the "My Account - Kingsyard VIP" page. Reward points never expire.',
    },
    {
      question: 'Can I cancel my membership?',
      answer:
        "Yes, you can cancel your membership anytime by contacting customer service to cancel your account. Keep in mind that terminating your membership means you'll only be able to shop as a guest, and any remaining unredeemed points and rewards will be forfeited.",
    },
    {
      question: 'Will I be notified of any updates on rewards program?',
      answer:
        'There may be some small changes to the policy, please refer to the page content. We will notify you of significant changes to the rewards program.',
    },
    {
      question: "What if I don't see my points yet after making a purchase or leaving a review?",
      answer:
        'No worries! Your points will be automatically credited to your account once your order is shipped or your product review is approved.',
    },
    {
      question:
        "I forgot to log into my account, how do I get my points added?  What should I do if my tier level is incorrect? What should I do if I'm unable to redeem my rewards?",
      answer: (
        <>
          <p>
            <span>Don&apos;t worry! If you have any questions, feel free to email us at</span>
            &nbsp;
            <a
              href='mailto:cs@e.kingsyard.com'
              className={clsx('underline')}
            >
              cs@e.kingsyard.com
            </a>
            <span>, and we will solve it ASAP.</span>
          </p>
        </>
      ),
    },
  ];

  const renderFaqs = isExpand ? faqs : faqs.slice(0, 3);

  return (
    <div
      className={clsx(
        props.className,
        'max-w-[1440px] bg-[#F6F6F6] px-2.5 py-[30px] font-poppins lg_mx-auto  lg_px-[110px] lg_py-[139px]',
      )}
    >
      <h2
        className={clsx(
          'font-poppins  text-lg font-[600]  leading-[22px] text-primary lg_text-center lg_text-[30px] lg_leading-10',
          'mb-5 lg_mb-[100px]',
        )}
      >
        FREQUENTLY ASKED QUESTIONS
      </h2>

      {renderFaqs.map((x, i, arr) => (
        <Fragment key={i}>
          <div className='text-sm font-normal uppercase leading-5 text-primary lg_text-lg lg_leading-[22px]'>
            {x.question}
          </div>
          <div className='mt-5 font-sans text-sm font-semibold leading-[18px] text-title'>{x.answer}</div>
          {i === arr.length - 1 ? null : <div className='my-5 h-px bg-[#adadad] lg_my-[50px]' />}
        </Fragment>
      ))}
      <button
        className=' mx-auto mt-[80px] flex items-center justify-center text-sm font-normal leading-5 text-[#A1C323] lg_text-base'
        onClick={() => {
          setIsExpand(x => !x);
        }}
        type='button'
      >
        <span className='underline'>{isExpand ? 'READ LESS QUESTIONS' : 'READ MORE QUESTIONS'}</span>
        <Image
          alt='down'
          src={downArrowPng}
          width={16}
          height={18}
          className={clsx('ml-2.5', isExpand && 'rotate-180')}
        />
      </button>
    </div>
  );
};

export default FrequentlyQuestion;
